import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, MessageCircle } from "lucide-react";
import { useSettings } from "@/contexts/SettingsContext";
import { buildWhatsAppLink } from "@/lib/whatsapp";

export default function Footer() {
    const { settings } = useSettings();
    const wa = buildWhatsAppLink(settings.whatsapp_number, "Hello Gold by SRN — I'd like to enquire about your collections.");

    return (
        <footer className="bg-ivory mt-24 border-t border-soft">
            <div className="max-w-[1480px] mx-auto px-6 lg:px-12 py-20 grid md:grid-cols-12 gap-10">
                <div className="md:col-span-5">
                    <div className="flex items-baseline gap-2">
                        <span className="font-serif text-4xl text-ink">Gold</span>
                        <span className="overline text-[9px]">by</span>
                        <span className="font-serif text-4xl italic text-bronze-deep">SRN</span>
                    </div>
                    <p className="mt-5 text-sm text-charcoal max-w-md leading-relaxed">
                        A wholesale gold jewellery manufacturer based in Jaipur, India. We craft bespoke 22K & 18K collections for small jewellers, brand owners & boutiques across the country.
                    </p>
                    <p className="overline mt-6">No retail. Trade enquiries only.</p>
                </div>

                <div className="md:col-span-3">
                    <p className="overline mb-5">Browse</p>
                    <ul className="space-y-3 text-sm text-charcoal">
                        <li><Link className="underline-grow" to="/catalog">Catalog</Link></li>
                        <li><Link className="underline-grow" to="/catalog?cat=Necklace">Necklaces</Link></li>
                        <li><Link className="underline-grow" to="/catalog?cat=Choker">Chokers</Link></li>
                        <li><Link className="underline-grow" to="/catalog?cat=Bangles">Bangles</Link></li>
                        <li><Link className="underline-grow" to="/about">Our Atelier</Link></li>
                        <li><Link className="underline-grow" to="/contact">Contact</Link></li>
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <p className="overline mb-5">Reach the Atelier</p>
                    <ul className="space-y-3 text-sm text-charcoal">
                        <li className="flex items-start gap-3">
                            <MessageCircle size={14} className="mt-1 text-bronze-deep" />
                            <a href={wa} target="_blank" rel="noreferrer" className="underline-grow">WhatsApp · {settings.phone_display}</a>
                        </li>
                        <li className="flex items-start gap-3"><Phone size={14} className="mt-1 text-bronze-deep" /><a href={`tel:${settings.phone_display.replace(/\s/g, '')}`} className="underline-grow">{settings.phone_display}</a></li>
                        <li className="flex items-start gap-3"><Mail size={14} className="mt-1 text-bronze-deep" /><a href={`mailto:${settings.email}`} className="underline-grow">{settings.email}</a></li>
                        <li className="flex items-start gap-3"><MapPin size={14} className="mt-1 text-bronze-deep" /><span>{settings.address}</span></li>
                        {settings.instagram && (
                            <li className="flex items-start gap-3"><Instagram size={14} className="mt-1 text-bronze-deep" />
                                <a href={settings.instagram} target="_blank" rel="noreferrer" className="underline-grow">@goldbysrn</a>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
            <div className="border-t border-soft py-6 text-center text-xs text-muted-ink flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4">
                <span>© {new Date().getFullYear()} Gold by SRN · Crafted in Jaipur with patience and fire.</span>
                <span className="hidden sm:inline text-soft">·</span>
                <a
                    href="https://app.emergent.sh/?utm_source=goldbysrn-footer"
                    target="_blank"
                    rel="noreferrer"
                    data-testid="footer-emergent-credit"
                    className="text-muted-ink hover:text-bronze-deep transition-colors"
                >
                    Made with Emergent
                </a>
            </div>
        </footer>
    );
}
